<svelte:head>
	<script
		defer
		src="https://static.cloudflareinsights.com/beacon.min.js"
		data-cf-beacon={'{"token": "2b45e47058bf4e129a8753f1fb4528d3"}'}
	></script>
</svelte:head>
